// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPaginationLeft: React.FC = () => {
    return (
        <svg
            width="22px"
            height="14px"
            viewBox="0 0 22 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Interactive-Elements/Selector/Pagination-Arrows/UI-:-Pagination-:-Arrow-:-Left"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <path
                        d="M13.1264242,12.6839041 L13.1264242,9.00510126 L0.522820949,9.00510126 C0.234115337,9.00510126 3.55271368e-15,8.77228409 3.55271368e-15,8.48517934 L3.55271368e-15,5.47130816 C3.55271368e-15,5.18420341 0.234115337,4.95138623 0.522820949,4.95138623 L13.1275233,4.95138623 L13.1275233,1.36148383 C13.1275233,0.985114275 13.2667468,0.611295147 13.5455603,0.357345895 C14.0837691,-0.132699648 14.8689164,-0.103916304 15.3638927,0.352973742 L21.5750935,6.08340966 C22.1418798,6.60697504 22.1418798,7.49889437 21.5750935,8.02245975 L15.3638927,13.7528957 C14.978097,14.0119458 14.4131426,14.1055827 13.9254939,13.8465326 C13.4404099,13.6363049 13.1264242,13.1604689 13.1264242,12.6839041 Z"
                        transform="translate(11.000092, 7.000108) scale(-1, 1) translate(-11.000092, -7.000108) "
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconPaginationLeft);
